import { Flex } from "@chakra-ui/layout";
import { Tag } from "@chakra-ui/tag";
import { CoresAnimal, PortesAnimal } from "core/features/animal/animal.data";
import { useMemo } from "react";

function useTabelaPetsColumns() {
  return useMemo(() => {
    return [
      {
        title: "Nome",
        dataIndex: "nome",
      },
      {
        title: "Porte",
        dataIndex: "porte",
        render: (porte: string) => {
          return (
            <Flex>
              <Tag variant="outline" colorScheme="orange" size="sm">
                {PortesAnimal.find((p) => p.value === porte)?.label || "--"}
              </Tag>
            </Flex>
          );
        },
      },
      {
        title: "Cor",
        dataIndex: "cor",
        render: (cor: string) => {
          return (
            <Flex>
              <Tag variant="outline" colorScheme="blue" size="sm">
                {CoresAnimal.find((c) => c.value === cor)?.label || "--"}
              </Tag>
            </Flex>
          );
        },
      },
    ];
  }, []);
}

export default useTabelaPetsColumns;
